import store from '@/store';
import audioFile from '@/assets/notification.mp3';

const audio = new Audio(audioFile);

// The first interaction enables attempts; the browser can still reject playback.
export function enableNotificationAudio() {
  if (store.state.soundMuted) return false;
  store.state.canPlay = true;
  return true;
}

export function pauseNotificationAudio() {
  audio.pause();
  audio.currentTime = 0;
}

export function setNotificationMuted(muted) {
  store.state.soundMuted = muted;
  if (muted) {
    localStorage.setItem('silenciar', 'true');
    store.state.canPlay = false;
    pauseNotificationAudio();
  } else {
    localStorage.removeItem('silenciar');
    return enableNotificationAudio();
  }
}

export async function playNotificationAudio() {
  if (store.state.soundMuted || !store.state.canPlay) return false;
  try {
    await audio.play();
    return true;
  } catch (error) {
    if (error.name === 'NotAllowedError') store.state.canPlay = false;
    return false;
  }
}
